import React from 'react'

function DeleteProperty() {
  return (
    <div>
       <h1>Deletye Property</h1>
    </div>
  )
}

export default DeleteProperty
